// extracted by mini-css-extract-plugin
export const base = "navigation-module--base--2isqy";
export const active = "navigation-module--active--3WSzz";
export const normal = "navigation-module--normal--12Sl_";
export const menu_base = "navigation-module--menu_base--udVRp";
export const menu_normal = "navigation-module--menu_normal--e_VrR";
export const menu_active = "navigation-module--menu_active--1Zkfg";